import { fromEvent, merge, tap } from 'rxjs';
import {
  RegisterExtensionEditorSetup,
  RegisterExtensionRender,
} from '../../types/registerExtension';
import { Editor, EditorOptions } from 'tinymce';
import { ModalController } from '@ionic/angular/standalone';
import { StoryService } from '../../../stories/story.service';
import { QuotationService } from './quotation.service';
import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ProfilePage } from 'src/app/pages/profile/profile.page';
import { CharacterPage } from 'src/app/pages/characters/pages/character/character.page';

const quotationExtensionRender: RegisterExtensionRender = (
  editor,
  injector
) => {
  const story = injector.get(StoryService, null);
  const router = injector.get(Router);
  const modalCtrl = injector.get(ModalController);
  return merge(
    ...Array.from(editor.querySelectorAll('[data-quotation]')).map((el) => {
      return fromEvent(el, 'click').pipe(
        tap(() => {
          if (el.getAttribute('data-quotationtype') === 'user') {
            const user = (story?.users() ?? []).find(
              (u) => u.id === el.getAttribute('data-quotation')
            );
            if (user) {
              modalCtrl
                .create({
                  component: ProfilePage,
                  componentProps: {
                    id: el.getAttribute('data-quotation'),
                  },
                })
                .then((modal) => modal.present());
            }
          }
          if (el.getAttribute('data-quotationtype') === 'char') {
            modalCtrl
              .create({
                component: CharacterPage,
                componentProps: {
                  story: story?.id(),
                  id: el.getAttribute('data-quotation'),
                  inModal: true,
                },
              })
              .then((modal) => modal.present());
            // router.navigate([
            //   '/',
            //   'stories',
            //   story.id(),
            //   'characters',
            //   el.getAttribute('data-quotation'),
            // ]);
          }
        })
      );
    })
  );
};

const quotationExtensionEditorSetup: RegisterExtensionEditorSetup = (
  editor: Editor,
  injector
) => {
  const ser = injector.get(QuotationService);
  const destroy = injector.get(DestroyRef);
  editor.on('input', function (event) {
    // Example: Execute a command if the user types a specific character
    const selectedNode = editor.selection.getNode();
    if (
      event.data === '@' &&
      event.inputType === 'insertText' &&
      !selectedNode.hasAttribute('data-quotation')
    ) {
      let random = Date.now();
      editor.execCommand('Delete');
      editor.execCommand(
        'mceInsertContent',
        false,
        '<span data-quotation data-random="' + random + '">@</span>&nbsp;'
      );

      const range = editor.getDoc().createRange();
      const sel = editor.getDoc().getSelection();

      // Trova l'elemento appena inserito
      const spanElement = editor
        .getBody()
        .querySelector('span[data-quotation][data-random="' + random + '"]');
      if (spanElement) {
        // Posizioniamo il cursore subito dopo il <span>
        range.setStart(spanElement, 1); // Posiziona il cursore dopo il <span>
        range.collapse(true); // Collassa il range

        // Rimuove la selezione attuale e aggiunge il nuovo range
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    }
  });
  editor.on('input', (event) => {
    const selectedNode = editor.selection.getNode();
    if (
      //event.inputType === 'deleteContentBackward' &&
      selectedNode.hasAttribute('data-quotation')
    ) {
      if (
        event.inputType === 'deleteContentBackward' &&
        selectedNode.getAttribute('data-quotation')?.length
      ) {
        editor.dom.remove(selectedNode);
        ser.currentInput.set(undefined);
      } else if (selectedNode.getAttribute('data-quotation')?.length) {
        if (event.data === ' ') {
          editor.execCommand('undo');
          const range = editor.getDoc().createRange();
          const sel = editor.getDoc().getSelection();

          range.setStartAfter(selectedNode);
          range.collapse(false); // Collassa il range

          // Rimuove la selezione attuale e aggiunge il nuovo range
          sel?.removeAllRanges();
          sel?.addRange(range);

          editor.focus();
        } else {
          editor.execCommand('undo');
        }
        ser.currentInput.set(undefined);
      } else if (selectedNode.innerText.trim().length > 0) {
        ser.currentInput.set(selectedNode.innerText.replace('@', ''));
      } else {
        ser.currentInput.set(undefined);
      }
    } else {
      ser.currentInput.set(undefined);
    }
  });
  ser.selectValue$.pipe(takeUntilDestroyed(destroy)).subscribe((val) => {
    const selectedNode = editor.selection.getNode();
    if (
      selectedNode.hasAttribute('data-quotation') &&
      !selectedNode.getAttribute('data-quotation')?.length
    ) {
      selectedNode.innerHTML = '@' + val.value;
      editor.focus();
      selectedNode.setAttribute('data-quotation', val.id);
      selectedNode.setAttribute('data-quotationtype', val.type);
      selectedNode.setAttribute('contentEditable', 'false');

      const range = editor.getDoc().createRange();
      const sel = editor.getDoc().getSelection();

      range.setStart(selectedNode, 1); // Posiziona il cursore dopo il <span>
      range.collapse(false); // Collassa il range

      // Rimuove la selezione attuale e aggiunge il nuovo range
      sel?.removeAllRanges();
      sel?.addRange(range);
    }
  });
  //   editor.ui.registry.addButton('quotationFormat', {
  //     text: 'quotation',
  //     onAction: () => {
  //       // Add the custom formatting
  //       editor.formatter.toggle('quotationFormat');
  //     },
  //   });
};
const quotationExtensionEditorFormat: EditorOptions['formats'] = {
  //   quotationFormat: {
  //     inline: 'span',
  //     attributes: { 'data-quotation': 'quotation' },
  //   },
};

export const quotationExtension = {
  render: quotationExtensionRender,
  setup: quotationExtensionEditorSetup,
  format: quotationExtensionEditorFormat,
};
